import React from "react";
import { Colors } from "../../config";
import styled from "styled-components";
import StatusChip from "./StatusChip";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { BOOKING_STATUS } from "../../config/Constants";

// const hasTrip = false;

const UpcomingTrips = ({ data }) => {
  const navigate = useNavigate();

  return (
    <>
      <SideContentHeader>
        <div>Upcoming business trip ({data?.length})</div>
        {data?.length > 0 && (
          <ViewAllLink onClick={() => navigate("/user/bookings")}>
            View More
          </ViewAllLink>
        )}
      </SideContentHeader>
      <ContentWrapper>
        {data?.length > 0 ? (
          <TripContainer>
            <RequestIdBox>Request ID {data[0]?.requestId || "-"}</RequestIdBox>
            <TripDetailsCard>
              <CardTitle>Trip Details</CardTitle>

              {data[0]?.travelDetails?.map((td) => (
                <>
                  <TripDetailsGrid>
                    <DetailItem align="left">
                      <Label>From /Destination</Label>
                      <Value>
                        {td?.from}-{td?.to}
                      </Value>
                    </DetailItem>
                    <DetailItem align="center">
                      <Label>Departure Date</Label>
                      <Value>
                        {td?.departureDate
                          ? dayjs(td.departureDate).format("DD MMM YYYY")
                          : "-"}
                      </Value>
                    </DetailItem>
                    <DetailItem align="right">
                      <Label>Return Date</Label>
                      <Value>
                        {td?.returnDate
                          ? dayjs(td.returnDate).format("DD MMM YYYY")
                          : "-"}
                      </Value>
                    </DetailItem>
                  </TripDetailsGrid>
                </>
              ))}
              {/* {data[0]?.travelDetails?.map((td) => (
               
              ))} */}
              <TripDetailsGrid>
                <DetailItem align="left">
                  <Label>Requested Date</Label>
                  <Value>
                    {data[0]?.createdAt
                      ? dayjs(data[0]?.createdAt).format("DD MMM YYYY")
                      : "-"}
                  </Value>
                </DetailItem>
                <DetailItem align="center">
                  <Label>Trip Type</Label>
                  <Value>{data[0]?.businessTripType?.toUpperCase()}</Value>
                </DetailItem>
                <DetailItem align="right">
                  <Label>Status</Label>
                  <StatusChip
                    color={Colors.brandTwo}
                    label={
                      data[0].status &&
                      (BOOKING_STATUS[data[0].status]
                        ? BOOKING_STATUS[data[0].status]
                        : data[0].status)
                    }
                  />
                </DetailItem>
              </TripDetailsGrid>
            </TripDetailsCard>
          </TripContainer>
        ) : (
          <>
            <NoTripImage
              src={require("../../assets/images/biz_no_upcoming_trip.png")}
              alt="No upcoming trips"
            />
            <InfoWrapper>
              <NoTripsText>No Upcoming trips</NoTripsText>
              <DescriptionText>
                Looks like you’re all set! No upcoming trips are scheduled at
                the moment. Ready to plan your next adventure or business
                journey? Start booking now!
              </DescriptionText>
            </InfoWrapper>
          </>
        )}
      </ContentWrapper>
    </>
  );
};

export default UpcomingTrips;

// ----------------------
// Styled Components
// ----------------------

const ViewAllLink = styled.div`
  font-size: 14px;
  color: ${Colors.white};
  text-decoration: underline;
  cursor: pointer;
`;

const SideContentHeader = styled.div`
  margin-top: 1.5rem;
  font-size: 1.1rem;
  color: ${Colors.white};
  display: flex;
  justify-content: space-between;
`;

const ContentWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
`;

const TripContainer = styled.div`
  width: 100%;
`;

const RequestIdBox = styled.div`
  width: 100%;
  margin-bottom: 0.5rem;
  background: ${Colors.brandTwo};
  color: ${Colors.prussianBlue};
  padding: 1rem 0.75rem;
  border-radius: 0.5rem;
  text-align: left;
  font-weight: 600;
  box-sizing: border-box;
`;

const TripDetailsCard = styled.div`
  background: ${Colors.white};
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
`;

const CardTitle = styled.div`
  font-size: 1.25rem;
  color: ${Colors.prussianBlue};
  font-weight: 600;
  text-align: left;
  margin-bottom: 8px;
`;

const TripDetailsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 0.9rem;
`;

const DetailItem = styled.div`
  width: 33.33%;
  padding: 12px 8px;
  box-sizing: border-box;
  text-align: ${(props) => props.align || "left"};
  display: flex;
  flex-direction: column;
  align-items: ${(props) =>
    props.align === "left"
      ? "flex-start"
      : props.align === "right"
        ? "flex-end"
        : "center"};
`;

const Label = styled.div`
  color: ${Colors.gullGray};
  margin-bottom: 4px;
  font-weight: 500;
`;

const Value = styled.div`
  color: ${Colors.black};
  font-weight: 500;
`;

const NoTripImage = styled.img`
  width: 200px;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 22rem;
`;

const NoTripsText = styled.div`
  color: ${Colors.white};
  font-size: 14px;
`;

const DescriptionText = styled.div`
  color: ${Colors.gray};
  font-size: 12px;
`;
